import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FavoriteIcon(props: IconProps) {
    return <Icon {...props} iconKey={"favorite"}/>
}
